import { createProvider } from '@nvision/services/data-provider';

import type { StatesParams } from '../../models';
import * as api from './api';
import { normalizeStates } from './normalize';

export const fetchStates = createProvider(
  async (params: StatesParams, { signal }: { signal?: AbortController['signal'] } = {}) => {
    const response = await api.fetchStates(params, { signal });
    return normalizeStates(response);
  },
);
